
<div class="input-group date-picker" >
    <span>
      <i class="fa fa-calendar" aria-hidden="true"></i>
    </span>
    <input type="text"   #datepicker  class=" form-control" autocomplete="off" (change)="validate()">

 </div>